import { NavigationButtons } from '@onegov/react-component-library';
import { Col, FormGroup, Heading, HorizontalRule, Input, Row } from '@snsw/react-component-library';
import { PlantItemRenewalEditItemPage } from 'plantItemRenewal/constants/plantItemRenewalEditItemPage';
import { updateInfos } from 'plantItemRenewal/redux/renewalItemsSlice';
import { getInfoCodeValue } from 'plantItemRenewal/utils/PlantItemRenewalHelpers';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { PagePath } from 'shared/constants/pagePath';
import styles from '../Page.module.scss';
import ScrollToTop from 'shared/utils/scrollToTop';
import { InfoCode } from 'shared/constants/InfoCode';

export const EditItem = () => {
  ScrollToTop();
  const PAGE_CONSTANTS = PlantItemRenewalEditItemPage;

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const item = location.state?.item;
  const itemAddress = location.state?.address;

  const [specificItemLocation, setSpecificItemLocation] = useState(getInfoCodeValue(item, InfoCode.specificLocation));
  const [uniqueIdentifier, setUniqueIdentifier] = useState(getInfoCodeValue(item, InfoCode.customersUid));

  const onSaveClick = () => {
    const tangibleInfos = [
      { infoCode: InfoCode.specificLocation, infoValue: specificItemLocation },
      { infoCode: InfoCode.customersUid, infoValue: uniqueIdentifier },
    ];

    dispatch(updateInfos({ tangibleRsn: item?.tangibleRsn, tangibleInfos }));
    navigate(PagePath.plantItemRenewalReviewItems, { replace: true });
  };

  const onCancelClick = () => {
    navigate(PagePath.plantItemRenewalReviewItems, { replace: true });
  };

  return (
    <>
      <Row>
        <Col span={6}>
          <Heading level={5} className={styles.noMarginB}>
            {PAGE_CONSTANTS.itemLocationLabel}:
          </Heading>
          <span>{itemAddress}</span>
          <Heading level={5} className={styles.noMarginB + ' ' + styles.marginTopOneHalf}>
            {PAGE_CONSTANTS.itemRegistrationNumberLabel}:
          </Heading>
          <span>{item?.tangibleName}</span>
          <Heading level={3} className={styles.noMarginB + ' ' + styles.marginTopOneHalf}>
            {PAGE_CONSTANTS.itemIdentifiersLabel}
          </Heading>
          <span>{PAGE_CONSTANTS.itemIdentifiersDesc}</span>
          <FormGroup
            id="specificItemLocation"
            label={PAGE_CONSTANTS.specificLocationLabel + ':'}
            helpMessage={
              <>
                For example, east wing. If the item has moved to a different address, you will need to complete this{' '}
                <a href={PlantItemRenewalEditItemPage.relocationNotificationFormUrl} target="_blank" rel="noreferrer">
                  notification form
                </a>
                .
              </>
            }
            margin={{ top: 'md' }}
          >
            <Input value={specificItemLocation} onChange={(e) => setSpecificItemLocation(e.target.value)} />
          </FormGroup>
          <FormGroup
            id="uniqueIdentifier"
            label={PAGE_CONSTANTS.uniqueIdentifierLabel + ':'}
            helpMessage={PAGE_CONSTANTS.uniqueIdentifierDesc}
            margin={{ top: 'md' }}
          >
            <Input value={uniqueIdentifier} onChange={(e) => setUniqueIdentifier(e.target.value)} />
          </FormGroup>
        </Col>
      </Row>

      <HorizontalRule />
      <NavigationButtons
        leftButtonConfig={{
          label: 'Save',
          onClick: onSaveClick,
        }}
        rightButtonConfig={{
          label: 'Cancel',
          onClick: onCancelClick,
        }}
      />
    </>
  );
};
